import { render, staticRenderFns } from "./leaveBoard.vue?vue&type=template&id=4b490b67&scoped=true"
import script from "./leaveBoard.vue?vue&type=script&lang=js"
export * from "./leaveBoard.vue?vue&type=script&lang=js"
import style0 from "./leaveBoard.vue?vue&type=style&index=0&id=4b490b67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b490b67",
  null
  
)

export default component.exports